//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.NodeSelectionBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"BreakdownName",1,0],[1,"NodeSelection",0,"Features.ShipDesign.NodeSelectionBuilder",0],[1,"Room",0,"SelectNXObjectList",0],[0,"Type",1,0]],[[[],"GetBreakdownType",{R_:{breakdownType:''}},0,0],[["breakdownType"],"SetBreakdownType",{},1,0],[[],"GetBreakdownSubType",{R_:{subBreakdownType:''}},0,0],[["subBreakdownType"],"SetBreakdownSubType",{},1,0],[[],"GetCurrentNode",{R_:{tNode:"TaggedObject"}},0,0],[["tNode"],"SetCurrentNode",{},1,0],[[],"GetParentNode",{R_:{tNode:"TaggedObject"}},0,0],[["tNode"],"SetParentNode",{},1,0]],[]];
SPLM.Features.ShipDesign.SpatialBreakdownBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SpatialBreakdownBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SpatialBreakdownBuilder.Types = Object.freeze({
    "Breakdown" : "Breakdown", "Volume" : "Volume"});

export default SPLM;